// src/components/auth/AuthCallback.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // The session should be automatically set by Supabase
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          throw error;
        }

        if (data?.session) {
          // This is a definite sign-in we should redirect from
          // Check if we have a lastPath stored
          const lastPath = sessionStorage.getItem('lastPath');
          // Only use lastPath if it exists and is not the root path
          if (lastPath && lastPath !== '/' && lastPath !== '/auth/callback') {
            sessionStorage.removeItem('lastPath');
            navigate(lastPath, { replace: true });
          } else {
            // Default to dashboard if no valid lastPath
            navigate('/dashboard', { replace: true });
          }
        } else {
          // If no session, go to login
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Error during auth callback:', err);
        setError(err.message);
        navigate('/', { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-red-50 text-red-500 p-4 rounded-lg">
          Authentication error: {error}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>
  );
};

export default AuthCallback;